import { render } from "./HelpButton.vue?vue&type=template&id=4b1658ca&scoped=true"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"

import "./HelpButton.vue?vue&type=style&index=0&id=4b1658ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b1658ca"

export default script